<template>
    <div class="content">
        <p class="title">Експорт</p>
        <div class="content_top">
            <p class="sub_title">Файл формується в форматі Microsoft Excel (XLSX). Оберіть необхідні параметри для експорту.</p>
            <a href="javascript:void(0);" @click="getCustomExcel()">
                <Button icon="pi pi-download" :loading="isExcelLoading" label="Ексель для розсилки по email" />
            </a>
        </div>

        <div class="tabs">
            <div class="content_tab content_tab-item" :class="{'active': activeTab === 1}" @click.prevent="selectTab(1)">
                <span>Напрямки</span>
            </div>
            <div class="content_tab content_tab-item" :class="{'active': activeTab === 2}" @click.prevent="selectTab(2)">
                <span>Бренди</span>
            </div>
        </div>
        <div class="tab_contents" v-if="activeTab === 1">
            <div class="tab_content">
                <label class="input_row">
                    <input type="checkbox" :checked="checkedAllCatalogs" @click="selectAllCatalogsTab()">
                    <span>Обрати всі напрямки</span>
                </label>
                <Tree v-model:selectionKeys="selectedCatalogs" :value="catalog" selectionMode="checkbox" class="catalog_tree"></Tree>
            </div>
            <div class="tab_content">
                <label class="input_row">
                    <input type="checkbox" :checked="checkedAllAttributes" @click="selectAllAttributesTab()">
                    <span>Обрати всі атрибути</span>
                </label>
                <Tree v-model:selectionKeys="selectedAttributes" :value="attributes" selectionMode="checkbox" class="catalog_tree"></Tree>
            </div>
        </div>
        <div class="tab_contents" v-if="activeTab === 2">
            <div class="tab_content">
                <label class="input_row">
                    <input type="checkbox" :checked="checkedAllBrands"  @click="selectAllBradsTab()">
                    <span>Обрати всі бренди</span>
                </label>
                <template v-if="getDataLoad">
                    <span class="data-loader">
                        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                    </span>
                </template>
                <Tree v-else v-model:selectionKeys="selectedBrands" :value="brands" selectionMode="checkbox" class="catalog_tree"></Tree>
            </div>
            <div class="tab_content">
                <label class="input_row">
                    <input type="checkbox" :checked="checkedAllAttributes"  @click="selectAllAttributesTab()">
                    <span>Обрати всі атрибути</span>
                </label>
                <Tree v-model:selectionKeys="selectedAttributes" :value="attributes" selectionMode="checkbox" class="catalog_tree"></Tree>
            </div>
        </div>
        <div class="bottom_container">
            <a class="download_spec" v-if="loading">Зачекайте...</a>
            <a class="download_spec" v-else v-on:click="getExcel()">Експортувати в Excel</a>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import axios from "axios";
import { nextTick } from 'vue'
import Tooltip from 'primevue/tooltip';
import FormHelper from './mixins/form_helper';
import Tree from 'primevue/tree';
import Label from '../Jetstream/Label.vue';
import Button from 'primevue/button';

export default {
    directives: {
        Tooltip,
    },
    mixins: [FormHelper],
    layout: AppLayout,
    components: {
        AppLayout,
        Tree,
        Label,
        Button,
    },
    data() {
        return {
            activeTab: 1,
            checkedAllCatalogs: true,
            checkedAllAttributes: true,
            checkedAllBrands: true,
            selectedCatalogs: {},
            selectedAttributes: {},
            selectedBrands: {},
            loading: false,
            getDataLoad: false,
            isExcelLoading: false,
            
            catalog: [],
            brands: {},
            attributes: {},
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getExcel() {
            this.loading = true
            axios.post(this.route('api.vector.export-catalog-sku-files-excel'), {
                catalog: this.selectedCatalogs,
                attributes: this.selectedAttributes,
                brands: this.selectedBrands,
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.loading = false
            }).catch((error) => {
                this.loading = false
                console.log(error);
                window.scroll(0, 0);
            })
        },
        getData() {
            this.getDataLoad = true
            axios.post(this.route('api.vector.export-catalog-sku-files.data'), {
                catalog: this.selectedCatalogs,
            })
            .then((response) => {
                this.catalog = response.data.catalog
                this.brands = response.data.brands
                this.attributes = response.data.attributes

                this.selectAllCatalogsTab()
                this.selectAllBradsTab()
                this.selectAllAttributesTab()

                this.getDataLoad = false
            }).catch((error) => {
                this.getDataLoad = false
                console.log(error);
                window.scroll(0, 0);
            })
        },
        selectAllCatalogsTab() {
            if (Object.keys(this.selectedCatalogs).length === 0) {
                for (const [key, value] of Object.entries(this.catalog)) {
                    this.expandCatalogNode(value);
                }
                this.selectedCatalogs = { ...this.selectedCatalogs };
            } else {
                this.selectedCatalogs = {}
            }
        },
        expandCatalogNode(node) {
            if (node.children && node.children.length) {
                this.selectedCatalogs[node.key] = {
                    checked: true,
                    partialChecked: false,
                };

                for (let child of node.children) {
                    this.selectedCatalogs[child.key] = {
                        checked: true,
                        partialChecked: false,
                    };
                    this.expandCatalogNode(child);
                }
            }
        },
        selectAllAttributesTab() {
            if (Object.keys(this.selectedAttributes).length === 0) {
                for (let node of this.attributes) {
                    this.selectedAttributes[node.key] = {
                        checked: true,
                        partialChecked: false,
                    };
                }
            } else {
                this.selectedAttributes = {}
            }
        },
        selectAllBradsTab() {
            if (Object.keys(this.selectedBrands).length === 0) {
                for (const [key, value] of Object.entries(this.brands)) {
                    this.expandBrandNode(value);
                }

                this.selectedBrands = { ...this.selectedBrands };
            } else {
                this.selectedBrands = {}
            }
        },
        expandBrandNode(node) {
            this.selectedBrands[node.key] = {
                checked: true,
                partialChecked: false,
            };
            
            if (node.children && node.children.length) {
                for (let child of node.children) {
                    this.selectedBrands[child.key] = {
                        checked: true,
                        partialChecked: false,
                    };
                    this.expandBrandNode(child);
                }
            }
        },

        selectTab(tab) {
            // this.selectedCatalogs = {}
            // this.selectedAttributes = {}
            // this.selectedBrands = {}

            if (tab === 2) {
                this.getDataLoad = true
                axios.post(this.route('api.vector.export-catalog-sku-files.data'), {
                    catalog: this.selectedCatalogs,
                })
                .then((response) => {
                    this.selectedBrands = {}
                    this.brands = response.data.brands
                    
                    for (const [key, value] of Object.entries(this.brands)) {
                        this.expandBrandNode(value);
                    }

                    this.selectedBrands = { ...this.selectedBrands };

                    this.getDataLoad = false
                }).catch((error) => {
                    this.getDataLoad = false
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
            this.activeTab = tab

            // this.checkedAllCatalogs = false
            // this.checkedAllAttributes = false
            // this.checkedAllBrands = false

            // if (tab === 1) {
            //     this.checkedAllCatalogs = true
            //     this.checkedAllAttributes = true
            //     this.selectAllCatalogsTab()
            //     this.selectAllAttributesTab()
            // } else {
            //     this.checkedAllAttributes = true
            //     this.checkedAllBrands = true
            //     this.selectAllBradsTab()
            //     this.selectAllAttributesTab()
            // }
        },

        getCustomExcel() {
            if (this.isExcelLoading === false) {
                this.isExcelLoading = true
                axios.post(this.route('api.catalog.product.products.get_custom_excel'), this.filterParams,
                    {
                        responseType: 'blob'
                    }
                )
                .then(function (result) {
                    let blob = new Blob([result.data]);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Ексель для розсилки по email.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(() => {
                    this.isExcelLoading = false
                })
            } else {
                alert('Зачекайте, йде завантаження..');
            }
        }
    }
}
</script>

<style scoped>
.content {
    border-radius: 4px;
    border: 1px solid #C8E4FF;
    background: #FFF;
    padding: 16px;
}
.catalog_tree {
    width: 100%;
    border: none;
    padding: 0px;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    height: 50vh;
    overflow: auto;
}
.tabs {
    display: flex;
    align-items: center;
    overflow: auto;
}
.content_tab {
    border-bottom: 2px solid var(--border-border-subtle-01, #C6C6C6);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
    cursor: pointer;
    display: flex;
    gap: 8px;
    width: 252px;
    margin-top: 12px;
    justify-content: center;
    align-items: center;
    padding: 11px 16px;
    color: var(--text-text-secondary, var(--text-text-secondary, #525252));
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.16px;
}
.content_tab.active {
    border-bottom: 2px solid var(--border-border-interactive, #0F62FE);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
}
.content_tab-item {
    color: var(--text-text-primary, var(--text-text-primary, #161616));
    font-weight: 600;
}
.title {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
}
.tab_contents {
    width: 100%;
    display: flex;
    gap: 24px;
}
.tab_content {
    width: 50%;
}
input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}
.input_row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 1rem 2.4rem;
    margin-bottom: 17px;
    border-bottom: 1px solid #C6C6C6;
    cursor: pointer;
}
.input_row span {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.bottom_container {
    margin-top: 20px;
}
.download_spec {
    width: 300px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.data-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #356EEF;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #356EEF transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.content_top {
    display: flex;
    justify-content: space-between;
}
</style>
